module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-check-763b402cb7e4de60b995f33bf4104a47.svg";